// This file should only contain action type constants.
export const SET_MORE_REQUEST_DATA = 'SET_REQUEST_DATA';
export const SET_MY_CARS_DATA = 'SET_MY_CARS_DATA';
